import { Box, Typography } from '@mui/material';
import { colors } from '../../../styles/colors';
import Image from '../../../components/Image';

export const InfoComponent = ({ data }: any) => {
  return (
    <Box
      sx={{
        backgroundColor: colors.basics.white,
        border: `1px solid ${colors.border.grey}`,
        borderRadius: '4px',
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      <Typography
        sx={{
          padding: '20px',
          paddingBottom: '0px',
          fontSize: { sm: '20px', xs: '20px' },
          textAlign: { sm: 'start', xs: 'center' },
        }}
        variant='h2'
        lineHeight={'31.26px'}
      >
        Why American Sky?
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          // padding: { md: '0 20px' },
        }}
      >
        {data?.map((item: any, index: number) => {
          return (
            <Box key={index}>
              <Box
                className='heading-slider'
                sx={{
                  p: '10px 20px',
                  display: 'block',
                  width: '100%',
                  height: 'auto',
                  '& img': {
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    minHeight: '145px',
                    objectPosition: 'top',
                  },
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    gap: { sm: 2, xs: 0 },
                  }}
                >
                  <Box>
                    <Image
                      style={{
                        margin: 'auto',
                        justifyContent: 'center',
                        display: 'flex',
                        minHeight: 'auto',
                        padding: '10px 10px 20px',
                        height: '80px',
                        minWidth: '160px',
                        maxWidth: '160px',
                        // maxWidth: "80px"
                      }}
                      src={item?.imgURL}
                      alt='images'
                    />
                  </Box>
                  <Box
                    sx={{
                      // mt: '10px',
                      display: 'flex',
                      flexDirection: 'column',
                      textAlign: { xs: 'center', sm: 'start' },
                      gap: 1,
                      '& a': {
                        lineHeight: '1.25rem',
                        fontWeight: '500',
                        color: '#303030 !important',
                        marginBottom: '10px',
                        marginTop: '10px',
                        // fontSize: { xs: '16px', sm: '1.25rem' },
                        textDecoration: 'none',
                        '&:hover': {
                          textDecoration: 'underline',
                        },
                      },
                    }}
                  >
                    <Typography
                      dangerouslySetInnerHTML={{ __html: item.bodyHtml }}
                      sx={{
                        variant: 'h3',
                        lineHeight: '1.25rem',
                        fontWeight: 600,
                        color: '#303030 !important',
                        marginTop: '10px',
                        fontSize: { xs: '16px', sm: '18px !important' },
                        textDecoration: 'none',
                      }}
                    ></Typography>

                    <Box mt={'5px'}>
                      <Typography
                        dangerouslySetInnerHTML={{ __html: item.footerHtml }}
                        variant='body2'
                        fontWeight={500}
                        color={colors.grey[40]}
                        marginBottom={'10px'}
                        lineHeight={'1.25rem'}
                        fontSize={{ xs: '12px', sm: '14px' }}
                      >
                        {item?.footer}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};
